(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsController', [
        '$scope',
        'SharedAgendaService', 
        AgendaSettingsControllerFn
    ]);

    /* controlle for main agenda-settings */
    function AgendaSettingsControllerFn($scope, SharedAgendaService, SharedAgendaBroadcast) {
        var vm = this;

        activate();

        /* activation work */
        function activate() {
            // allow shared agenda-switch
            SharedAgendaService.allow();            
        }
    }
})();
